import {
    getBaseURL,
    getAPIKey,
    getOrigin,
    getUserToken,
} from '../../environment'
import { INotification } from '../../models/INotification'

const baseURL = getBaseURL()
const APIKey = getAPIKey()
const endpoint = '/news/notifications'
const origin = getOrigin()

export const getNotifications = async (
    source: string,
    limit: number,
    offset: number,
    search?: string
): Promise<{ data: INotification[]; total: number }> => {
    const params = new URLSearchParams()
    params.append('source', source)
    params.append('limit', limit.toString())
    params.append('offset', offset.toString())
    params.append('order', 'published:asc, updatedAt:desc')
    if (search) {
        params.append('search', search)
    }
    const url = `${baseURL}${endpoint}?${params.toString()}`
    return fetch(url, {
        method: 'GET',
        headers: {
            'x-api-key': APIKey,
            'x-origin': origin,
            authorization: `Bearer ${getUserToken()}`,
        },
    })
        .then((response: Response) => response.json())
        .catch((err) => {
            console.error('Erro: ', JSON.stringify(err))
            throw err
        })
}

export const createNotification = async (
    notification: INotification,
    files?: File[]
): Promise<{ data: INotification[] }> => {
    const notificationToSend = { ...notification }
    const formData = mountFormData(notificationToSend)
    files?.forEach((file, index) => {
        formData.append(index.toString(), file)
    })
    return fetch(`${baseURL}${endpoint}`, {
        method: 'POST',
        headers: {
            'x-api-key': APIKey,
            'x-origin': origin,
        },
        body: formData,
    })
        .then((response: Response) => response.json())
        .catch((err) => {
            console.error('Erro: ', JSON.stringify(err))
            throw err
        })
}

export const updateNotification = async (
    notification: INotification,
    files?: File[]
): Promise<{ data: INotification[] }> => {
    const notificationToSend = { ...notification }
    const formData = mountFormData(notificationToSend)
    files?.forEach((file, index) => {
        formData.append(index.toString(), file)
    })
    return fetch(`${baseURL}${endpoint}/${notification.id}`, {
        method: 'PUT',
        headers: {
            'x-api-key': APIKey,
            'x-origin': origin,
        },
        body: formData,
    })
        .then((response: Response) => response.json())
        .catch((err) => {
            console.error('Erro: ', JSON.stringify(err))
            throw err
        })
}

export const getNotificationById = async (
    notificationId: string
): Promise<{ data: INotification[] }> => {
    return fetch(`${baseURL}${endpoint}/${notificationId}`, {
        method: 'GET',
        headers: {
            'x-api-key': APIKey,
            'x-origin': origin,
        },
    })
        .then((response: Response) => response.json())
        .catch((err) => {
            console.error('Erro: ', JSON.stringify(err))
            throw err
        })
}

export const deleteNotification = async (
    notificationId: string
): Promise<{ data: string; status: number }> => {
    return fetch(`${baseURL}${endpoint}/${notificationId}`, {
        method: 'DELETE',
        headers: {
            'x-api-key': APIKey,
            'x-origin': origin,
        },
    })
        .then(async (response: Response) => {
            return {
                data: await response.json(),
                status: response.status,
            }
        })
        .catch((err) => {
            console.error('Erro: ', JSON.stringify(err))
            throw err
        })
}

function mountFormData(obj: object) {
    const formData = new FormData()
    Object.entries(obj).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return
        }
        if (value instanceof Array) {
            formData.append(key, JSON.stringify(value))
            return
        }

        formData.append(key, value)
    })
    return formData
}
